export type AlertProps = {
	type?: string;
	title: string;
	text?: string;
};

export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
